import { useTranslation } from "react-i18next";
import { ChangeOrgTextField } from "./ChangeOrgTextField";

interface Props {
  currentValue: string;
}

export const ChangeCity = ({ currentValue }: Props) => {
  const { t } = useTranslation();

  return (
    <ChangeOrgTextField
      currentValue={currentValue}
      fieldName="city"
      label={t("City")}
      helperText={t("Please provide your company's city")}
      toastMessage={t("City has been updated!")}
      buildPatch={(value) => ({ city: { value } })}
    />
  );
};
